import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DeliveryOrderService {
    constructor(private http: HttpClient) {}

    getSingleDeliveryOrder(deliveryOrderId: number): Observable<any> {
        return this.http.get<any>(`api:///DeliveryOrder/GetSingleDeliveryOrder/${deliveryOrderId}`);
    }

    getDeliveryOrderList(filter: any): Observable<any> {
        return this.http.post('api:///DeliveryOrder/DeliveryOrderList', filter);
    }

    getDeliveryOrders(id) {
        return this.http.get<any[]>(`api:///DeliveryOrder/GetDeliveryOrders/${id}`);
    }

    getRelationTerminalOptionsOnDeliveryOrder(vesselVisitId) {
        return this.http.get<any>(`api:///DeliveryOrder/GetRelationTerminalOptionsOnDeliveryOrder/${vesselVisitId}`);
    }

    getBerthsBasedOnTerminal(relationId) {
        return this.http.get<any>(`api:///DeliveryOrder/GetBerthsBasedOnTerminal/${relationId}`);
    }

    getServiceProvidersOnDeliveryOrder(vesselVisitId?: number) {
        return this.http.post<any>('api:///DeliveryOrder/GetOrganizationsForDeliveryOrder', { vesselVisitId });
    }

    getSystemsBasedOnOrganization(terminalId, organizationId) {
        return this.http.get<any>(`api:///DeliveryOrder/GetSystemsBasedOnOrganization/${terminalId}/${organizationId}`);
    }

    getDeliveryOrderSummary(deliveryOrderId: number): Observable<any> {
        return this.http.get<any>(`api:///DeliveryOrder/GetDeliveryOrderSummary/${deliveryOrderId}`);
    }

    getDeliveryOrderPrintData(id: number): Observable<any> {
        return this.http.get<any>(`api:///DeliveryOrder/GetDeliveryOrderPrintData/${id}`);
    }

    addDeliveryOrder(model: any) {
        return this.http.post<any>('api:///DeliveryOrder/AddNewDeliveryOrder', model);
    }

    deleteDeliveryOrder(deliverOrderIds: number[]) {
        return this.http.post<any>('api:///DeliveryOrder/DeleteDeliveryOrder/', deliverOrderIds);
    }

    sendDeliveryOrder(deliverOrderId: number) {
        return this.http.post<any>('api:///DeliveryOrder/SendDeliveryOrder/', deliverOrderId);
    }

    getSingleDeliveryOrderItem(deliveryOrderItemId: number): Observable<any> {
        return this.http.get<any>(`api:///DeliveryOrder/GetSingleDeliveryOrderItem/${deliveryOrderItemId}`);
    }

    getDeliveryOrderItems(deliveryOrderId: number): Observable<any> {
        return this.http.get<any[]>(`api:///DeliveryOrder/GetDeliveryOrderItems/${deliveryOrderId}`);
    }

    getDeliveryOrderItemActuals(ids: any): Observable<any> {
        return this.http.post<any>('api:///DeliveryOrder/GetDeliveryOrderItemActuals', ids);
    }

    addDeliveryOrderItems(models: any[]) {
        return this.http.post<any>('api:///DeliveryOrder/AddNewDeliveryOrderItems', models);
    }

    deleteDeliveryOrderItem(deliveryOrderItemIds: any) {
        return this.http.post<any>('api:///DeliveryOrder/DeleteDeliveryOrderItem/', deliveryOrderItemIds);
    }

    addAttachment(model: any) {
        return this.http.post<any>(`api:///DeliveryOrder/AddAttachment`, model);
    }

    removeAttachment(ids: any) {
        return this.http.post<any>(`api:///DeliveryOrder/RemoveAttachment`, ids);
    }

    saveDeliveryOrderItemQuantities(model: any) {
        return this.http.post<any>(`api:///DeliveryOrder/SaveDeliveryOrderItemQuantities`, model);
    }

    completeDeliveryOrder(model: any) {
        return this.http.post<any>('api:///DeliveryOrder/CompleteDeliveryOrder', model);
    }

    cancelDeliveryOrder(model: any) {
        return this.http.post<any>('api:///DeliveryOrder/CancelDeliveryOrder', model);
    }

    revertDeclinedStatus(deliveryOrderId: number) {
        return this.http.post<any>(`api:///DeliveryOrder/RevertDeclinedStatus/${deliveryOrderId}`, null);
    }

    downloadDeliveryOrderExcelTemplate() {
        return this.http.get<any>(`api:///DeliveryOrder/DownloadDeliveryOrderExcelTemplate`);
    }

    uploadExcel(model: any): Observable<any> {
        return this.http.post<any>(`api:///DeliveryOrder/UploadExcelOnDeliveryOrder`, model);
    }
}
